import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import PropTypes from 'prop-types'; 
const ReCaptcha = ({ onVerify }) => {
  const recaptchaRef = React.createRef();

  const handleOnChange = (value) => {
    onVerify(value);
  };

  return (
    <div className="recaptcha-wrapper">
      <ReCAPTCHA
        ref={recaptchaRef}
        sitekey={process.env.REACT_APP_RECAPTCHA_SECRET_KEY}
        onChange={handleOnChange}
        sameSite="None"
        secure={true}
        theme="light"
        size="normal"
        hl="en"
        onErrored={() => {
          console.error('reCAPTCHA error occurred');
        }}
        onExpired={() => {
          console.warn('reCAPTCHA expired');
          onVerify(null);
        }}
      />
    </div>
  );
};

export default ReCaptcha;